module.exports = __webpack_public_path__ + "img/swisscom-logo-type.bc11574f.svg";